export default "__VITE_ASSET__DBXATi62__"